module.exports = __webpack_public_path__ + "img/new image - gllxe.11dd9908.jpg";